import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { PqrInfoWeb } from '../../../../../../shared/types/modules/pqr';
import { PqrInfoWebProps } from './props';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';

import {
    asyncGetCities,
    asyncGetCountries,
} from '../../../../../../services/location.service';
import { asyncGetParams } from '../../../../../../services/param.service';

export const usePqrInfo = ({
    data,
    onChangeData,
    onChangeFormik,
}: PqrInfoWebProps) => {
    const [channelPresentsFailures, setChannelPresentsFailures] = useState<
        ISelect[]
    >([]);
    const [countries, setCountries] = useState<ISelect[]>([]);
    const [locations, setLocations] = useState<ISelect[]>([]);
    const [types, setTypes] = useState<ISelect[]>([]);
    const [country, setCountry] = useState<ISelect>();
    const [extra, setExtra] = useState<string | undefined>('');
    const [name, setName] = useState<string | undefined>('');
    const [isColombia, setIsColombia] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const onSubmit = (data: PqrInfoWeb) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema(isColombia),
        onSubmit,
    });

    useEffect(() => {
        if (!formik.values.type) {
            setIsOpen(false);
        } else {
            const extraParam =
                types?.filter((param) => param.id === formik.values.type)[0] ||
                undefined;
            setExtra(extraParam?.extra);
            setName(extraParam?.name);
            setIsOpen(true);
        }
    }, [formik.values.type, types]);

    useEffect(() => {
        const selectedCountry = countries.find(
            (country) => country.id === formik.values.country
        );
        setIsColombia(selectedCountry?.name?.toLowerCase() === 'colombia');
    }, [formik.values.country]);

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue(
            'channelPresentsFailure',
            data?.channelPresentsFailure || ''
        );
        formik?.setFieldValue('country', country?.id || data?.country || '');
        formik?.setFieldValue('location', data?.location || '');
        formik?.setFieldValue('type', data?.type || '');
        formik?.setFieldValue('detail', data?.detail || '');
        formik?.setFieldValue('acceptTerms', data?.acceptTerms || false);
    }, [data, country]);

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_CHANNEL_PRESENTS_FAILURE).then((items) =>
            setChannelPresentsFailures(items)
        );
        asyncGetCountries().then((items) => {
            setCountries(items);
            const selectedCountry = items.find(
                (country) => country.name?.toLowerCase() === 'colombia'
            );
            setCountry(selectedCountry);
        });
        asyncGetCities().then((items) => setLocations(items));
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) => {
            const newParamsFilter = params?.filter(
                (param) => param?.code !== `${ParamEnum.PQR_TYPE}_QEX`
            );
            setTypes(newParamsFilter);
        });
    }, []);

    const handleClose = () => {
        setIsOpen(false);
        setExtra('');
    };

    return {
        formik,
        channelPresentsFailures,
        countries,
        locations,
        types,
        isColombia,
        isOpen,
        name,
        extra,
        handleClose,
    };
};
